import React, { useState } from "react";
import { X, Clipboard, ClipboardCheck } from "react-bootstrap-icons";
import * as Styled from "./EmbedCodeModal.styled";
import { useAuth } from "../../../behavioral";

interface EmbedCodeModalProps {
  outletId: string;
  profileId: string;
  outletName: string;
  onClose: () => void;
}

export const EmbedCodeModal: React.FC<EmbedCodeModalProps> = ({ outletId, profileId, outletName, onClose }) => {
  const [copied, setCopied] = useState(false);
  const [closing, setClosing] = useState(false);

  const authInfo = useAuth();

  const handleClose = () => {
    setClosing(true);
    setTimeout(onClose, 200);
  };

  const dummyCode = `<div id="cembooClientJoinNowButton"></div>

<div id="cemboo-media-library"></div>

<script
  src="${process.env.REACT_APP_CDN_URL}/library/index.js"
  data-client-id="${authInfo?.user?.username}"
  data-outlet-id="${outletId}">
</script>
`;

  const handleCopy = () => {
    navigator.clipboard.writeText(dummyCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Styled.Overlay $closing={closing} onClick={handleClose}>
      <Styled.Modal $closing={closing} onClick={(e) => e.stopPropagation()}>
        <Styled.Header>
          <Styled.Title>Embed Code</Styled.Title>
          <Styled.CloseButton onClick={handleClose}>
            <X size={22} />
          </Styled.CloseButton>
        </Styled.Header>

        <Styled.MetaRow>
          <Styled.MetaBadge>Outlet Name: <span>{outletName}</span></Styled.MetaBadge>
        </Styled.MetaRow>

        <Styled.MetaRow>
          <Styled.MetaBadge>Outlet ID: <span>{outletId}</span></Styled.MetaBadge>
          <Styled.MetaBadge>Profile ID: <span>{profileId}</span></Styled.MetaBadge>
        </Styled.MetaRow>


        <Styled.CodeBlock>{dummyCode}</Styled.CodeBlock>

        <Styled.CopyRow>
          <Styled.CopyButton onClick={handleCopy}>
            {copied ? <ClipboardCheck size={16} /> : <Clipboard size={16} />}
            {copied ? "Copied!" : "Copy Code"}
          </Styled.CopyButton>
        </Styled.CopyRow>
      </Styled.Modal>
    </Styled.Overlay>
  );
};
